"use strict";
var MenuItem = (function () {
    function MenuItem() {
    }
    return MenuItem;
}());
exports.MenuItem = MenuItem;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/models/menu-item.js
// module id = 39
// module chunks = 0